var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.container }, [
    _c("div", { class: _vm.$style.info }, [
      _c("h3", { class: _vm.$style.infoHeader }, [
        _vm._v("\n      " + _vm._s(_vm.storefront.contactInfoTitle) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.$style.infoContent }, [
        _c(
          "div",
          [
            _c("NsLogo", {
              attrs: {
                "is-mysite": true,
                "mysite-image-url": _vm.distributor.distImage,
                "is-white": true,
                "alt-text": "Nu Skin Logo on the Mysite Footer",
                "link-url": ""
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { class: _vm.$style.infoContentDetails }, [
          _vm.distributor.distName
            ? _c("h3", { class: _vm.$style.name }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.distributor.distName) +
                    "\n        "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.distributor.distEmail
            ? _c("div", { class: _vm.$style.email }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.distributor.distEmail) +
                    "\n        "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.distributor.distPhone
            ? _c("div", { class: _vm.$style.phone }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.distributor.distPhone) +
                    "\n        "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          (_vm.distributor.distSocialMedia || []).length > 0
            ? _c(
                "div",
                { class: _vm.$style.socialLinks },
                _vm._l(_vm.distributor.distSocialMedia, function(link) {
                  return _c(
                    "a",
                    {
                      key: link.label,
                      class: _vm.$style.socialLink,
                      attrs: { href: link.href, target: "_blank" }
                    },
                    [
                      _c("NsIcon", {
                        attrs: { "icon-name": link.iconName, color: "#fff" }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(link.label))])
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { class: _vm.$style.logo },
      [
        _c("NsLogo", {
          attrs: {
            "is-white": true,
            "is-powered-by": true,
            "alt-text": "Nu Skin Is Powered By Logo on the Mysite Footer",
            "link-url": ""
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }